<template>
    <div>
        <div class="text-left">
            <h3>รายการเช็ค</h3>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">หมายเลขเช็ค</label>
                </b-col>
                <b-col sm="5">
                    <label class="col-form-label">
                        {{ form.ref_no }}
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">วันที่เช็ค</label>
                </b-col>
                <b-col sm="5">
                    <template v-if="form.date">
                        <label class="col-form-label">
                            {{ form.date | moment("DD/MM/YYYY") }}
                        </label>
                    </template>
                    <template v-else>-</template>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">จำนวนเงิน</label>
                </b-col>
                <b-col sm="5">
                    <label class="col-form-label">
                        {{ form.amount | currency }}
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">สถานะ</label>
                </b-col>
                <b-col sm="5">
                    <label class="col-form-label">
                        <input v-model="form.status"
                               type="radio"
                               name="status"
                               value=""/>
                        &nbsp;รายการรอจ่าย
                    </label>
                    <label class="col-form-label" style="margin-left: 20px">
                        <input v-model="form.status"
                               type="radio"
                               name="status"
                               value="1"/>
                        &nbsp;P
                    </label>
                </b-col>
            </b-row>
            <b-row sm="10">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">วันที่เช็คจ่าย (P)</label>
                </b-col>
                <b-col sm="5">
                    <date-picker
                        v-model="form.approve_date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        confirm
                        placeholder="วันที่จ่าย">
                    </date-picker>&nbsp;&nbsp;
                </b-col>
            </b-row>
            <b-row sm="12">
                <b-col sm="5" class="col text-right">
                    <label class="col-form-label">บัญชีสำหรับนำเช็คออก</label>
                </b-col>
                <b-col sm="6" v-if="form.transaction && form.transaction.bank">
                    <span>{{ form.transaction.bank.account_number }} {{ form.transaction.bank.account_name }}</span>
                </b-col>
            </b-row>
            <br>
        </div>
        <div class="col text-center">
            <button type="button" @click="submitData"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก
            </button>
            &nbsp&nbsp
            <button @click="cancelData"
                    type="button"
                    class="btn btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
        <div style="display: none">{{ validateDate }}</div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker';
import moment from 'moment';

export default {
    name: "cheque-rr-payoff-modal",
    components: {DatePicker},
    data() {
        return {
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            form: state => {
                return state.RRPayoff.cheque_form;
            },
        }),
        validateDate() {
            this.form.approve_date = moment(this.form.approve_date).format("YYYY-MM-DD");
            let date_year = moment(this.form.approve_date).format('YYYY'); //get year
            if (date_year <= 2000) {
                let current_year = moment().format("YYYY");
                this.form.approve_date = moment(this.form.approve_date).format(+current_year + "-MM-DD")
            }
        }
    },
    methods: {
        submitData() {
            if (this.form.approve_date) {
                this.form.approve_date = moment(this.form.approve_date).format("YYYY-MM-DD");
            } else {
                this.form.approve_date = "";
            }
            this.$emit("submit", this.form);
        },
        cancelData() {
            this.$emit("submit", 0)
        }
    }
}
</script>

<style scoped>

</style>
